import React from 'react';

const CookiePolicy = () => {
  return (
<div className="policy-page">
  <div className="container">
    <div className="policy-header">
    <h1>Cookie Policy</h1>
<p>Last updated: March 2025</p>

    </div>

    <div className="policy-content">
    <div className="policy-section">
  <h2>What Are Cookies?</h2>
  <p>
    Cookies are small text files stored on your device when you visit a website.
    They enhance your user experience by remembering preferences, analyzing site traffic, and enabling essential features.
  </p>

  <h2>How We Use Cookies</h2>
  <p>
    Our website uses cookies for the following purposes:
  </p>
  <ul>
    <li><strong>Essential Cookies:</strong> Required to ensure the functionality and security of the website.</li>
    <li><strong>Performance Cookies:</strong> Help us analyze traffic and improve the user experience.</li>
    <li><strong>Advertising Cookies:</strong> Used to personalize ads and measure their effectiveness.</li>
  </ul>

  <h2>Managing Cookies</h2>
  <p>
    You can manage your cookie preferences through your browser settings. Disabling cookies may affect how certain features of our website function.
  </p>
  <p>
    For more information on managing cookies, visit 
    <a href="https://www.allaboutcookies.org/" target="_blank" rel="noopener noreferrer">All About Cookies</a>.
  </p>
</div>

    </div>
  </div>
</div>

  );
};

export default CookiePolicy;